import React from 'react';
import PropTypes from 'prop-types';
import { ACTIVITY_FILTERS } from './activityUtils';

/**
 * Segmented pill filter for the activity feed. Replaces a native <select>: with
 * only seven options the choices are worth showing at a glance, and the active
 * one stays visible while scrolling the feed.
 */
const ActivityFilterTabs = ({ value, onChange, counts }) => (
  <div
    role="tablist"
    aria-label="Filter activities by type"
    className="tw-flex tw-items-center tw-gap-1 tw-p-1 tw-rounded-xl tw-bg-slate-100 tw-overflow-x-auto tw-max-w-full"
  >
    {ACTIVITY_FILTERS.map((option) => {
      const active = option.value === value;
      const count  = counts?.[option.value];
      return (
        <button
          key={option.value}
          type="button"
          role="tab"
          aria-selected={active}
          onClick={() => onChange(option.value)}
          className={`tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3 tw-h-7 tw-rounded-lg tw-text-xs tw-font-semibold tw-border-0 tw-cursor-pointer tw-whitespace-nowrap tw-transition-colors
            ${active
              ? 'tw-bg-white tw-text-slate-900 tw-shadow-sm'
              : 'tw-bg-transparent tw-text-slate-500 hover:tw-text-slate-700'}`}
        >
          {option.label}
          {count > 0 && (
            <span className={`tw-text-[10px] tw-font-bold tw-px-1.5 tw-rounded-full tw-leading-4
              ${active ? 'tw-bg-primary-50 tw-text-primary-700' : 'tw-bg-slate-200 tw-text-slate-500'}`}>
              {count}
            </span>
          )}
        </button>
      );
    })}
  </div>
);

ActivityFilterTabs.propTypes = {
  value:    PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  /** Optional badge counts keyed by filter value. */
  counts:   PropTypes.object,
};

ActivityFilterTabs.defaultProps = { counts: undefined };

export default ActivityFilterTabs;
